export default __webpack_public_path__ + "static/media/hht1_ep05_timeline_q04_b.9e04acb4.png";